import React, { forwardRef, useCallback } from 'react';
import { SharedValue } from 'react-native-reanimated';

import { TableItem } from '../../../store/types';
import { WheelCarousel, WheelCarouselHandle } from '../common/WheelCarousel';
import { TableCard } from '../LobbyTable/TableCard';

export type RoomTablesCarouselHandle = WheelCarouselHandle;

type Props = {
	tables: TableItem[];
	roomSlug?: string;
	activeIndex: number;
	onActiveIndexChange: (index: number) => void;
	width: number;
	height: number;
	cardWidth: number;
	cardHeight: number;
	progress?: SharedValue<number>;
	/** Passed to every card; see TableCard. */
	onVipRequired?: () => void;
};

const RoomTablesCarouselInner = (
	{
		tables,
		roomSlug,
		activeIndex,
		onActiveIndexChange,
		width,
		height,
		cardWidth,
		cardHeight,
		progress,
		onVipRequired,
	}: Props,
	ref: React.Ref<RoomTablesCarouselHandle>,
) => {
	const renderItem = useCallback(
		({ item, index }: { item: TableItem; index: number }) => (
			<TableCard
				table={item}
				roomSlug={roomSlug}
				index={index}
				totalCount={tables.length}
				cardWidth={cardWidth}
				cardHeight={cardHeight}
				progress={progress}
				framed
				onVipRequired={onVipRequired}
			/>
		),
		[cardHeight, cardWidth, onVipRequired, progress, roomSlug, tables.length],
	);

	return (
		<WheelCarousel
			ref={ref}
			data={tables}
			renderItem={renderItem}
			activeIndex={activeIndex}
			onActiveIndexChange={onActiveIndexChange}
			width={width}
			height={height}
			cardWidth={cardWidth}
			cardHeight={cardHeight}
			progress={progress}
		/>
	);
};

export const RoomTablesCarousel = forwardRef(RoomTablesCarouselInner);

export default RoomTablesCarousel;
